import { SiteConfig } from "../../types";

export const _config: SiteConfig = {
  isDefault: false,
  showTidio: false,
  enableStripeBilling: false,
  serviceName: "Tutore",
  publicUrl: "https://ai.tutore.eu",
  pwaServiceName: "Tutore",
  appLogoPath: "/partner/tutore/logo.png",
  appLogoHeight: "30px",
  landingLogoPath: "/partner/tutore/logo.png",
  landingLogoHeight: "30px",
  hubLogoPath: "/partner/tutore/icon.png",
  hubLogoHeight: "70px",
  favicon: "/partner/tutore/icon.png",
  pwaIcons: [
    {
      src: "/partner/tutore/icon.png",
      type: "image/png",
      sizes: "192x192",
    },
  ],
  overrideLanding: true,
  emailsSender: "info@lang-services.com",
  adminEmail: "ewa.marcinik-baran@tutore.eu",
  // adminPhoneNumber: "REPLACE_WITH_PHONE",
  reviewLink: null,
  copyright: "Tutore",
  showLanguageGuides: true,
  bioPrompt: `
    You are a language tutor at Tutore. We help people connect across cultures by making language learning practical and approachable. Our focus is to give learners the skills and confidence to communicate naturally in everyday conversations.
  `,
  siteColors: {
    special: {
      desktopSidebar: "#fff",
      desktopSidebarBorderColor: "#ddd",
      desktopSidebarText: "#000",
      desktopSidebarTextHover: "#eee",
      chatAsideMenu: "#333",
      mobileNavBackgroundColor: "#333",
      mobileNavBackgroundContrastColor: "#ffffff",
      mobileNavBorderColor: "#333",
      speakInputIdle: "var(--chakra-colors-brand-primary-main)",
      speakInputRecording: "var(--chakra-colors-brand-primary-800)",
      speakInputRecordingCancel: "var(--chakra-colors-brand-primary-900)",
    },
  },
  colors: {
    primary: {
      main: "#823189",
      mainContrast: "#fff",
      "50": "#faf6fa",
      "100": "#eadceb",
      "200": "#d7bdd9",
      "300": "#c199c4",
      "400": "#b484b8",
      "500": "#a368a8",
      "600": "#944f9a",
      "700": "#83328a",
      "800": "#6f2a75",
      "900": "#511e55",
    },
    secondary: {
      main: "#f6cb07",
      mainContrast: "#000",
      "50": "#fef8dc",
      "100": "#fae06b",
      "200": "#ebc207",
      "300": "#c5a306",
      "400": "#b09105",
      "500": "#957b04",
      "600": "#7d6704",
      "700": "#655303",
      "800": "#554602",
      "900": "#3d3302",
    },
    tertiary: {
      main: "#f6cb07",
      mainContrast: "#000",
      "50": "#fef8dc",
      "100": "#fae06b",
      "200": "#ebc207",
      "300": "#c5a306",
      "400": "#b09105",
      "500": "#957b04",
      "600": "#7d6704",
      "700": "#655303",
      "800": "#554602",
      "900": "#3d3302",
    },
  },
};
